import { render, staticRenderFns } from "./instory.vue?vue&type=template&id=2090fdc5&scoped=true"
import script from "./instory.vue?vue&type=script&lang=js"
export * from "./instory.vue?vue&type=script&lang=js"
import style0 from "./instory.vue?vue&type=style&index=0&id=2090fdc5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2090fdc5",
  null
  
)

export default component.exports